import { localStorageSupported } from '#lib/helper/browser.js';
import { guessDeviceType } from '#lib/helper/device.js';
import { isDoNotDisturbActive } from '#lib/stores/doNotDisturb.js';
import { NotificationSound, UserDeviceType } from '#lib/types/generated/index.js';

export function getAvailableSounds(): NotificationSound[] {
	return Object.values(NotificationSound);
}

export const isSoundAllowed = () => {
	if (!localStorageSupported()) {
		return false;
	}

	if (isDoNotDisturbActive()) {
		return false;
	}

	// Do not play sounds on mobile devices
	if (guessDeviceType() === UserDeviceType.Mobile) {
		return false;
	}

	// If the settings does not exist, sound is allowed by default
	if (localStorage.getItem('muted') === null) {
		localStorage.setItem('muted', 'false');
	}

	return localStorage.getItem('muted') === 'false';
};

let soundsCached: Record<string, HTMLAudioElement | undefined> = {};
export const playSound = (sound: string, ignoreMute: boolean = false): Promise<void> => {
	if (!sound || sound === 'none') {
		return Promise.resolve();
	}

	if (!isSoundAllowed() && !ignoreMute) {
		return Promise.resolve();
	}

	let audio = soundsCached[sound];
	if (!audio) {
		audio = new Audio(`/sounds/${sound}.mp3`);
		soundsCached[sound] = audio;
	}

	if (!audio.paused) {
		audio.currentTime = 0; // Remise à zéro de l'audio
	}
	return audio.play().catch((e: Error) => {
		console.warn('Audio playback prevented by browser:', e);
	});
};
